
import { defineComponent, toRefs, reactive, PropType } from "@vue/runtime-core";
import { Batch } from "@/interfaces/Batch";
import { Burst } from "@/interfaces/Burst";
import { isBurstSelected, toggleBurst, maxBurstsSelected, removeBurst, addBurst } from "@/helpers/store";
import { formatTime } from "@/helpers/time";
import VueFeather from "vue-feather";
import { computed, ComputedRef } from "vue";
import BurstItem from "@/components/BurstItem.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { downloadBurst } from "@/helpers/helpers";

export default defineComponent({
  components: {
    LoadingSpinner,
    VueFeather,
    BurstItem,
  },
  props: {
    batch: {
      required: true,
      type: Object as PropType<Batch>,
    },
    plotGraph: {
      required: false,
      type: Function as PropType<() => void>,
    },
    setToggleError: {
      required: true,
      type: Function as PropType<(x: Error) => void>,
    },
  },
  setup(props) {
    const state = reactive({
      batch: props.batch,
      burstDownloading: null as null | number,
      plotGraph: props.plotGraph,
      setToggleError: props.setToggleError,
    });

    const sortedBursts: ComputedRef<Burst[]> = computed(() =>
      state.batch.Bursts.concat().sort((a, b) => a.SensorName.localeCompare(b.SensorName))
    );

    const topBatchTags: ComputedRef<string[]> = computed(() =>
      Object.entries(state.batch.BatchTags)
        .filter((entry) => {
          if (
            entry[0] != "Customer" &&
            entry[0] != "Units" &&
            entry[0] != "NodeName" &&
            entry[0] != "Rig" &&
            entry[0] != "NodeMac"
          )
            return entry;
        })
        .map((entry) => `${entry[0]}: ${entry[1]}`)
    );

    const toggle_burst = (burst: Burst) => {
      try {
        toggleBurst(burst);
      } catch (error) {
        if (error instanceof Error) {
          state.setToggleError(error);
        }
      }
    };

    const toggleBatch = (batch: Batch) => {
      const selected = batchSelected(batch);
      try {
        sortedBursts.value.map((burst) => (selected ? removeBurst(burst) : addBurst(burst)));
      } catch (error) {
        if (error instanceof Error) {
          state.setToggleError(error);
        }
      }
    };

    const batchSelected = (batch: Batch) =>
      batch.Bursts.filter((burst) => isBurstSelected(burst.BurstID)).length ? true : false;

    return {
      ...toRefs(state),
      downloadBurst,
      toggle_burst,
      maxBurstsSelected,
      toggleBatch,
      batchSelected,
      formatTime,
      sortedBursts,
      topBatchTags,
    };
  },
});
